import { Injectable } from "@angular/core";
import { Resolve } from "@angular/router";
import { Observable } from "rxjs";
import { ItensService } from "../services/itens.service";

@Injectable({
  providedIn: 'root'
})
export class ItensResolver implements Resolve<boolean> {

  constructor(private service: ItensService) { }

  resolve(): Observable<any> {
    return this.service.findAll();
  }
}

@Injectable({
  providedIn: 'root'
})
export class ItensCombosResolver{

  constructor(private service: ItensService) { }

  resolve(id:number = null): Observable<any> {
    return this.service.getListCombos(id);
  }
}
@Injectable({
  providedIn: 'root'
})
export class ItensResolverId {

  constructor(private service: ItensService) { }

  getById(id:number): Observable<any> {
    return this.service.getById(id);
  }
}
@Injectable({
  providedIn: 'root'
})
export class ItensFullResolverId {

  constructor(private service: ItensService) { }

  getFullById(id:number,agency_id:number): Observable<any> {
    return this.service.getFullById(id,agency_id);
  }
}